import {
  DeviantArt,
  Dribbble,
  Drive,
  Dropbox,
  Facebook,
  Flickr,
  GooglePhotos,
  Instagram,
  PrivateSite,
  Public,
  Shutterstock,
  VisitorsUploads,
  Unsplash,
  WixSite,
  Vimeo,
  WixVideo,
  Boards,
  MultiSearch,
} from '@wix/media-manager-sdk';
import { RecommendedSource } from './sources/RecommendedSource';
import { ExternalSource, MainSource } from '../../constants/Source';
import { SearchSource } from './sources/SearchSource';
import { RecommendedHomeSource } from './sources/RecommendedHomeSource';

export const SOURCE_ADAPTERS = {
  [MainSource.All]: SearchSource,
  [MainSource.Boards]: Boards,
  [MainSource.Home]: RecommendedHomeSource,
  [MainSource.SiteFiles]: PrivateSite,
  [MainSource.VisitorsUploads]: VisitorsUploads,
  [MainSource.Trash]: PrivateSite,
  [MainSource.MediaFromWix]: Public,
  [MainSource.Shutterstock]: Shutterstock,
  [MainSource.Unsplash]: Unsplash,
  [MainSource.Recommended]: RecommendedSource,
  [MainSource.NTT]: Public,
  [MainSource.Yell]: Public,
  [MainSource.Enterprise]: Public,
  [MainSource.MultiSearch]: MultiSearch,
  [ExternalSource.Facebook]: Facebook,
  [ExternalSource.Dribbble]: Dribbble,
  [ExternalSource.GoogleDrive]: Drive,
  [ExternalSource.Dropbox]: Dropbox,
  [ExternalSource.Vimeo]: Vimeo,
  [ExternalSource.Instagram]: Instagram,
  [ExternalSource.Flickr]: Flickr,
  [ExternalSource.DeviantArt]: DeviantArt,
  [ExternalSource.WixSite]: WixSite,
  [ExternalSource.WixVideo]: WixVideo,
  [ExternalSource.GooglePhotos]: GooglePhotos,
};
